import { render } from "./CsvFormatRequirements.vue?vue&type=template&id=b530f1fa&scoped=true"
import script from "./CsvFormatRequirements.vue?vue&type=script&lang=js"
export * from "./CsvFormatRequirements.vue?vue&type=script&lang=js"

import "./CsvFormatRequirements.vue?vue&type=style&index=0&id=b530f1fa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/etl/etl/outerspace-admin-2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b530f1fa"]])

export default __exports__